
import React from 'react';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Promise } from '@/data/promises';
import StatusBadge from './StatusBadge';
import { formatDate } from '@/utils/date';

interface PromiseListProps {
  promises: Promise[];
}

const PromiseList = ({ promises }: PromiseListProps) => {
  return (
    <div className="w-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Title</TableHead>
            <TableHead>Politician</TableHead>
            <TableHead>Party</TableHead>
            <TableHead>Sector</TableHead>
            <TableHead>Date Made</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {promises.map((promise) => (
            <TableRow key={promise.id} className="hover:bg-muted/50">
              <TableCell className="font-medium">
                <Link to={`/promise/${promise.id}`} className="hover:text-nepal-blue">
                  {promise.title}
                </Link>
              </TableCell>
              <TableCell>{promise.politician}</TableCell>
              <TableCell>{promise.politicalParty}</TableCell>
              <TableCell>{promise.sector}</TableCell>
              <TableCell>{formatDate(promise.dateMade)}</TableCell>
              <TableCell>
                <StatusBadge status={promise.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PromiseList;
